export const OffBoarding = {
    path: '/off_boardings',
    name: 'off_boardings',
    component: () => import('@/views/Boarding/OffBoardings.vue'),
    children: [
        {
            path: '/off_boardings/add',
            name: 'off_boardings.add',
            component: () => import('@/views/Boarding/Form/OffBoardingForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/off_boardings/edit/:id',
            name: 'off_boardings.edit',
            component: () => import('@/views/Boarding/Form/OffBoardingForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/off_boardings/delete/:id',
            name: 'off_boardings.delete',
            component: () => import('@/views/Boarding/Form/OffBoardingForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/off_boardings/view/:id',
            name: 'off_boardings.view',
            component: () => import('@/views/Boarding/Form/OffBoardingForm.vue'),
            props: {viewAction: true}
        },
        {
            path: '/off_boardings/documents/:id',
            name: 'off_boardings.documents',
            component: () => import('@/views/Edms/Document/ModuleDocumentPage.vue'),
            props: {module: "OFF_BOARDING"}
        },
        {
            path: '/off_boardings/template_applications/:id',
            name: 'off_boardings.template_applications',
            component: () => import('@/views/Edms/TemplateApplication/ModuleTemplateApplicationPage.vue'),
            props: {module: "OFF_BOARDING"}
        },
    ],
}